import * as React from 'react';
import { Box, Button, ButtonProps, Grid, Typography } from '@mui/material';
import $ from "jquery";
import { DataGrid, GridCsvExportOptions, GridCsvGetRowsToExportParams, GridToolbarContainer, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Common from '../../utilities/common';
import Layout from '../../components/Utilities/Layout';
import EntitySettings from '../../components/EntitySettings';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'niveles_permisos' })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export interface IUserState {
    data: any[];
}

export default class NivelesPermisos extends React.Component<{}, IUserState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: []
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Layout breadcrumb={
                [
                    {
                        title: 'Inicio',
                        url: '/'
                    },
                    {
                        title: 'Configuración',
                        url: '/settings'
                    },
                    {
                        title: 'Niveles de permisos',
                        url: ''
                    }
                ]
            }>
                <Box className='stepper'>
                    <Grid container>
                        <Grid item xs={1}>
                            <Typography>
                                <GppGoodOutlinedIcon className='mainIcon'/>
                            </Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography className='mainTitle'>
                            Niveles de permisos
                            </Typography>
                        </Grid>
                        <SecurityTrimmer entity={Entity.NivelesPermisos} permission={PermissionLevel.Ver}>
                            <Grid item xs={2} className='entitySettings'>
                                <EntitySettings entity={Entity.NivelesPermisos}/>
                            </Grid>
                        </SecurityTrimmer>
                    </Grid>
                </Box>
                <Box className='main'>
                    <DataGrid
                        autoHeight
                        slots={{ toolbar: CustomToolbar }}
                        slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                        rows={this.state.data}
                        hideFooter={this.state.data.length <= 30}
                        columns={[
                            { 
                                field: 'id', 
                                headerName: 'ID', 
                                width: 50
                            },
                            { field: 'nombre', headerName: 'Nombre', width: 200 },
                            { field: 'descripcion', headerName: 'Descripción', width: 600 }
                        ]}
                    />
                </Box>
            </Layout>
        )
    }

    private Get(): void {
        let url = `${Common.END_POINT}/permissions/levels`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }
}